import ReportView, { type ReportColumn } from '../../../components/reports/ReportView';

const COLUMNS: ReportColumn[] = [
  { key: 'employer_name', label: 'Employer' },
  { key: 'reason_code', label: 'Reason' },
  { key: 'amount', label: 'Amount', align: 'right', type: 'money' },
  { key: 'outstanding', label: 'Outstanding', align: 'right', type: 'money' },
  { key: 'due_date', label: 'Due Date' },
  { key: 'days_outstanding', label: 'Days Outstanding', align: 'right' },
  { key: 'bucket', label: 'Bucket' },
];

export function AgeingScheduleReport() {
  return (
    <ReportView
      title="Penalty Ageing Schedule"
      description="Outstanding penalties by employer, bucketed by days overdue (current, 1-30, 31-60, 61-90, 91-120, 120+)."
      endpoint="/reports/penalties/ageing-schedule"
      columns={COLUMNS}
      xlsx
    />
  );
}
